/**
 * Two fingers on the 2D map (phase 6): pinch to zoom and drag to pan, the spot under the fingers staying under them.
 * One finger keeps the tools' gestures (tap to place, drag to move). Pure; SketchCanvas.tsx tracks the pointers.
 */
import { clampMpp, screenToEnu, type View } from "../editor/viewport.ts";

type Pt = [number, number];

export interface Pinch {
  view: View;
  /** the two fingers' middle and distance when the pinch began (screen pixels in the map) */
  mid: Pt;
  dist: number;
}

export function pinchStart(view: View, a: Pt, b: Pt): Pinch {
  return { view, mid: [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2], dist: Math.max(1, Math.hypot(b[0] - a[0], b[1] - a[1])) };
}

/** The view while two fingers move: zoomed by how far apart they are, and the map point first under their middle
 * under it now. */
export function pinchView(p: Pinch, a: Pt, b: Pt, w: number, h: number): View {
  const mid: Pt = [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
  const dist = Math.max(1, Math.hypot(b[0] - a[0], b[1] - a[1]));
  const at = screenToEnu(p.view, w, h, p.mid[0], p.mid[1]);
  const mpp = clampMpp((p.view.mpp * p.dist) / dist);
  return { mpp, cx: at[0] - (mid[0] - w / 2) * mpp, cy: at[1] + (mid[1] - h / 2) * mpp };
}
